import React from 'react';
import { Outlet } from 'react-router-dom';
import ClientLayout from './client/ClientLayout';

function ClientDashboard() {
  return (
    <ClientLayout>
      <Outlet />
    </ClientLayout>
  );
}

export default ClientDashboard;